module.exports = __webpack_public_path__ + "static/media/triangle_copy_4.faf27f9a.svg";